module.exports = __webpack_public_path__ + "static/media/calender.4a05f495.svg";